import React, { Component } from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { connect } from 'react-redux'

import { EmailInput, Wrapper } from 'SRC/ui/FormElementsNew'

export const Email = () => {
  const formik = useFormikContext()

  if (!formik.values) return null

  const emailError = formik.errors.newUser && formik.errors.newUser.email && formik.touched.newUser && formik.touched.newUser.email
    ? formik.errors.newUser.email
    : ''

  return (
    <React.Fragment>
      <Wrapper isError={emailError}>
        <EmailInput
          id='newUser-email'
          title='Email'
          value={formik.values.newUser.email}
          onChange={email => {
            console.log('textvalue', email)

            formik.setFieldValue('newUser.email', email)
          }}
        />

        <ErrorMessage
          name='newUser.email'
          render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
        />
      </Wrapper>
    </React.Fragment>
  )
}

